import type { TabsProps } from "antd";
import { useTranslation } from "react-i18next";
import { EquipmentEnumsProvider } from "./context/EquipmentEnumsContext";
import EquipmentLedger from "./pages/EquipmentLedger";
import MaintainUpcomingPage from "./pages/MaintainUpcoming";
import MyBorrowed from "./pages/MyBorrowed";
import { EquipmentPageTabs } from "./style";

// 固定页签使用稳定 key，确保重渲染时页签身份不变。
const TAB_LEDGER_KEY = "equipment-ledger";
const TAB_MY_BORROWED_KEY = "equipment-my-borrowed";
const TAB_MAINTAIN_UPCOMING_KEY = "equipment-maintain-upcoming";

// 设备管理入口，提供共享枚举上下文并组织三个业务页签。
const Equipment = () => {
  const { t } = useTranslation();

  const tabItems: TabsProps["items"] = [
    {
      key: TAB_LEDGER_KEY,
      label: t("equipment.equipmentLedger"),
      children: <EquipmentLedger />,
    },
    {
      key: TAB_MY_BORROWED_KEY,
      label: t("equipment.myBorrowed"),
      children: <MyBorrowed />,
    },
    {
      key: TAB_MAINTAIN_UPCOMING_KEY,
      label: t("equipment.maintainUpcomingQuery"),
      children: <MaintainUpcomingPage />,
    },
  ];

  // 非激活页签会被销毁，重新进入时由对应页面重新加载数据。
  return (
    <EquipmentEnumsProvider>
      <EquipmentPageTabs
        destroyInactiveTabPane
        items={tabItems}
        type="card"
      />
    </EquipmentEnumsProvider>
  );
};

export default Equipment;
